export default __webpack_public_path__ + "static/cover-12-18802e840f905325b6a93624c2053e16.jpg";